import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-one', 'ClockOne', [["path",{"d":"M12 6v6l2.5-4","key":"svg-0"}],["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0","key":"svg-1"}]]);